import { Dimension } from '@/Enums/ReportBuilder/Dimension.enum';
import { Metric } from '@/Enums/ReportBuilder/Metric.enum';
import { CustomReportChannel } from '@/Enums/ReportBuilder/ReportChannel.enum';
import { IControlOption, IGroupedControlOption } from '@/Interfaces/ControlOption.interface';
import { OmniplatformChannel } from '@/types/ReportBuilder/Omniplatform.type';
import {
  getDimensionOptions as getBeeswaxDimensionOptions,
  getMetricOptions as getBeeswaxMetricOptions,
} from './beeswax';
import {
  METRICS_OPTIONS as YOUTUBE_METRICS_OPTIONS,
  getDimensionOptions as getYoutubeDimensionOptions,
} from './youtube';

const PLATFORM_LABELS: Record<OmniplatformChannel, string> = {
  [CustomReportChannel.Beeswax]: 'Streaming TV, OLV, Display, Audio',
  [CustomReportChannel.Youtube]: 'YouTube',
};

export const createPlatformOption = (value: OmniplatformChannel): IControlOption<string, OmniplatformChannel> => ({
  label: PLATFORM_LABELS[value],
  value,
});

const getOmniplatformChannels = (): OmniplatformChannel[] => {
  return Object.values(CustomReportChannel).filter(c => c !== CustomReportChannel.Omniplatform);
};

export const PLATFORMS_OPTIONS: IControlOption<string, OmniplatformChannel>[] =
  getOmniplatformChannels().map(createPlatformOption);

export const getDimensionsOptionsMap = (
  includeOrganization: boolean,
): Record<OmniplatformChannel, IGroupedControlOption<string, Dimension>[]> => ({
  [CustomReportChannel.Beeswax]: getBeeswaxDimensionOptions({ includeOrganization }),
  [CustomReportChannel.Youtube]: getYoutubeDimensionOptions({ includeOrganization }),
});

export const METRICS_OPTIONS_MAP: Record<OmniplatformChannel, IControlOption<string, Metric>[]> = {
  [CustomReportChannel.Beeswax]: getBeeswaxMetricOptions(),
  [CustomReportChannel.Youtube]: YOUTUBE_METRICS_OPTIONS,
};
